import { useRef, useState, useEffect } from 'react';
import {
  Button,
  Select,
  Typography,
  MenuItem,
  ListItemText,
} from '@mui/material';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import {
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
} from '@mui/icons-material';
import VizzleSlider from '../../slider/VizzleSlider';
import { playTextToSpeech, cancelTts, VOICE_TYPES } from '../../../services/tts/TextToSpeechServiceV2';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './TextToSpeechSettingsFormV2.scss';
import { HIGHLIGHT_COLORS } from '../../../services/tts/TextToSpeechService';

const defaultProps = {
  ttsConfig: {},
  onChange: () => {},
};

const TextToSpeechSettingsFormV2 = (props) => {
  const { ttsConfig, onChange } = { ...defaultProps, ...filterUndefined(props) };
  const tts = useRef(null);
  const [ttsValue, setTtsValue] = useState(ttsConfig);
  useEffect(() => {
    setTtsValue(ttsConfig);

    return () => {
      cancelTts();
    };
  }, [ttsConfig]);
  const handlePlaySampleButtonClick = async () => {
    await playTextToSpeech([tts.current], ttsConfig);
  };

  return (
    <div className='text-to-speech-settings-form-v2'>
      <VizzleSlider
        label='Volume'
        // defaultValue={ttsConfig.volume || 10}
        value={ttsValue.volume}
        step={1}
        min={1}
        max={10}
        onChange={(e, value) => { setTtsValue({ ...ttsValue, volume: value }); }}
        onChangeCommitted={(e, value) => { onChange('volume', value); }}
        name='tts-slider-volume'
      />
      <br />
      <div className='selector-container' data-test='tts-voice-menu-container'>
        <Typography variant='subtitle1' fontWeight={500} data-test='tts-voice-menu-label'>
          Voices
        </Typography>
        <Select
          value={ttsConfig.voice === null || ttsConfig.voice === undefined ? '' : ttsConfig.voice}
          variant='outlined'
          onChange={(e) => { onChange('voice', e.target.value); }}
          data-test='tts-voice-menu-selector'
          renderValue={(selected) => (VOICE_TYPES.find((v) => selected === v.value) || { name: '' }).name}
          inputProps={{
            'aria-label': 'Voices',
          }}
        >
          <ListItemText><Typography className='tts-list-title'>Voices</Typography></ListItemText>
          {VOICE_TYPES.map((item) => (
            <MenuItem
              className='tts-list-item'
              key={item.key}
              value={item.value}
              data-test={`tts-voice-menu-option-${item.name}`}
            >
              {
                item.value === ttsConfig.voice ? <CheckBoxIcon className='checkbox-tts' color='primary' /> : <CheckBoxOutlineBlankIcon className='checkbox-tts' color='primary' />
              }
              <ListItemText>{item.name} <VolumeUpIcon /></ListItemText>
            </MenuItem>
          ))}
        </Select>
      </div>
      <br />
      <div className='color-selector-container' data-test='tts-highlight-container'>
        <Typography variant='subtitle1' fontWeight={500} data-test='tts-highlight-label'>
          Highlight
        </Typography>
        <Select
          value={ttsConfig.highlightColor === null || ttsConfig.highlightColor === undefined ? '' : ttsConfig.highlightColor}
          variant='outlined'
          onChange={(e) => { onChange('highlightColor', e.target.value); }}
          data-test='tts-highlight-selector'
          inputProps={{
            'aria-label': 'Highlight Color',
          }}
        >
          {HIGHLIGHT_COLORS.map((option) => (
            <MenuItem key={option.key} value={option.value} data-test={`tts-highlight-${option.name}`}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
        <div style={{ backgroundColor: ttsConfig.highlightColor }} className='tts-color' data-test='tts-color' />
      </div>
      <br />
      <div className='sample'>
        <Button variant='contained' className='btn-primary' onClick={handlePlaySampleButtonClick} data-test='tts-play-sample-action'>
          PLAY SAMPLE
        </Button>
        <div className='sample-text'>
          <div ref={tts}>
            Welcome to Vizzle NextGen.
            <br />
            Content Created by Teachers for Teachers.
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextToSpeechSettingsFormV2;
